"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@hotmart/cosmos/dist/nav/nav.css");
